import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { PersonAdd } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import AuthCaptcha from '../components/forms/AuthCaptcha';

const generateCaptchaChallenge = (length: number = 6) => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
};

const Register: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [captchaChallenge, setCaptchaChallenge] = useState(generateCaptchaChallenge());
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [error, setError] = useState('');
  const { register, state } = useAuth();
  const navigate = useNavigate();

  const refreshCaptcha = (clearError: boolean = true) => {
    setCaptchaChallenge(generateCaptchaChallenge());
    setCaptchaAnswer('');
    if (clearError) {
      setCaptchaError('');
    }
  };

  const handleSubmit = async () => {
    setError('');
    setCaptchaError('');

    if (captchaAnswer.trim().toUpperCase() !== captchaChallenge) {
      setCaptchaError('Captcha does not match. Please try again.');
      refreshCaptcha(false);
      return;
    }

    try {
      await register(name, email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.message);
      refreshCaptcha();
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    void handleSubmit();
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <PersonAdd sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
          <Typography variant="h4">रजिस्टर / Register</Typography>
        </Box>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleFormSubmit} noValidate>
          <TextField
            fullWidth
            label="नाम / Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="ईमेल / Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            required
          />
          <TextField
            fullWidth
            label="पासवर्ड / Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            margin="normal"
            required
          />
          <AuthCaptcha
            challengeText={captchaChallenge}
            value={captchaAnswer}
            error={captchaError}
            onChange={(value) => {
              setCaptchaAnswer(value);
              if (captchaError) {
                setCaptchaError('');
              }
            }}
            onRefresh={refreshCaptcha}
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => void handleSubmit()}
            disabled={state.isLoading || !captchaAnswer.trim()}
          >
            रजिस्टर करें / Register
          </Button>
          <Typography align="center">
            <Link to="/login">पहले से अकाउंट है? लॉगिन करें / Already have account? Login</Link>
          </Typography>
        </form>
      </Paper>
    </Container>
  );
};

export default Register;